// src/components/ui/IconBox.js
import React from 'react';
import './ui.css';

const IconBox = ({ 
  icon: Icon, 
  variant = 'blue',   // Options: 'blue', 'green', 'red', 'yellow', 'dark'
  size = 16, 
  padding = '8px',
  borderRadius = '12px',
  className = '',
  style = {}
}) => {
  
  const gradientMap = {
    blue: 'linear-gradient(135deg, #0284C7, #38BDF8)',
    green: 'linear-gradient(135deg, #059669, #10B981)',
    red: 'linear-gradient(135deg, #DC2626, #F87171)',
    yellow: 'linear-gradient(135deg, #D97706, #FBBF24)',
    dark: 'linear-gradient(135deg, #0F172A, #1E293B)'
  };

  const shadowMap = {
    blue: '0 4px 12px rgba(2, 132, 199, 0.2)',
    green: '0 4px 12px rgba(5, 150, 105, 0.2)',
    red: '0 4px 12px rgba(220, 38, 38, 0.2)',
    yellow: '0 4px 12px rgba(217, 119, 6, 0.2)',
    dark: '0 6px 14px rgba(15, 23, 42, 0.2)'
  };

  if (!Icon) return null;

  return (
    <div 
      className={`ui-icon-box-container ${className}`}
      style={{
        background: gradientMap[variant],
        boxShadow: shadowMap[variant],
        padding: padding,
        borderRadius: borderRadius,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        border: '1px solid rgba(255, 255, 255, 0.3)',
        boxSizing: 'border-box',
        color: '#FFFFFF',
        ...style
      }}
    >
      <Icon size={size} color="#FFFFFF" strokeWidth={2.5} />
    </div>
  );
};

export default IconBox;